import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top, behavior: "smooth" });
}

export default function Footer() {
  const { t } = useTranslation();

  const SectionLink = ({ id, label }) => (
    <li>
      <button
        onClick={() => scrollToId(id)}
        className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors text-left"
        data-testid={`footer-${id}`}
      >
        {label}
      </button>
    </li>
  );

  return (
    <footer className="bg-slate-50 border-t border-slate-200 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="font-display font-bold text-slate-900 text-lg tracking-tight">
            Admission<span className="text-amber-600">Crafts</span>
          </div>
          <p className="text-[12px] text-slate-500 mt-1">{t("footer.tagline")}</p>
          <p className="text-[13px] text-slate-600 mt-3 leading-relaxed">{t("footer.blurb")}</p>
        </div>

        {/* Product */}
        <div>
          <h4 className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-3">{t("footer.product")}</h4>
          <ul className="space-y-2">
            <SectionLink id="how-it-works" label={t("footer.howItWorks")} />
            <SectionLink id="pricing"      label={t("footer.pricing")} />
            <SectionLink id="top-colleges" label={t("footer.topColleges")} />
            <SectionLink id="branches"     label={t("footer.branchGuide")} />
            <SectionLink id="cap-guide"    label={t("footer.capGuide")} />
          </ul>
        </div>

        {/* Partners */}
        <div>
          <h4 className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-3">{t("footer.partners")}</h4>
          <ul className="space-y-2">
            <li>
              <Link to="/partners" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors" data-testid="footer-partners-link">
                {t("footer.partnerProgramme")}
              </Link>
            </li>
            <li>
              <Link to="/portal/login" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors" data-testid="footer-partner-signin">
                {t("footer.signInPartner")}
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-3">{t("footer.legal")}</h4>
          <ul className="space-y-2">
            <li><Link to="/privacy" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors">{t("footer.privacy")}</Link></li>
            <li><Link to="/terms"   className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/refund"  className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors">{t("footer.refund")}</Link></li>
            <li><Link to="/help/videos" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors" data-testid="footer-video-library">Video guides</Link></li>
            <li>
              <a href="mailto:support@admissioncrafts.com" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors" data-testid="footer-contact-email">
                support@admissioncrafts.com
              </a>
            </li>
            <li>
              <a href="tel:+912048564281" className="text-[13px] text-slate-600 hover:text-slate-900 transition-colors font-semibold" data-testid="footer-contact-phone">
                020 4856 4281
                <span className="block text-[11px] font-normal text-slate-500">Sales &amp; Service · Mon–Sat 10am–7pm</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 text-[11px] text-slate-500 text-center">
          {t("footer.copyright")}
        </div>
      </div>
    </footer>
  );
}
